const SENSITIVE_KEY = /authorization|cookie|secret|token|password|api[-_]?key|signature/i;

export function useWebhookHook() {
  const redactSensitiveData = (value: unknown): unknown => {
    const redact = (nestedValue: unknown): unknown => {
      if (Array.isArray(nestedValue)) return nestedValue.map(redact);
      if (!nestedValue || typeof nestedValue !== "object") return nestedValue;

      return Object.fromEntries(
        Object.entries(nestedValue).map(([key, childValue]) => [
          key,
          SENSITIVE_KEY.test(key) ? "[REDACTED]" : redact(childValue),
        ])
      );
    };

    return redact(value);
  };

  const redactUrl = (value: string): string => {
    try {
      const url = new URL(value);
      url.username = url.username ? "[REDACTED]" : "";
      url.password = url.password ? "[REDACTED]" : "";
      for (const key of url.searchParams.keys()) {
        if (SENSITIVE_KEY.test(key)) url.searchParams.set(key, "[REDACTED]");
      }
      return url.toString();
    } catch {
      return value;
    }
  };

  return { redactSensitiveData, redactUrl };
}
